import { Component, EventEmitter, OnChanges, Input, OnInit, Output, SimpleChanges } from '@angular/core';

import { AppComponent } from '../../app.component';
import { HubService } from '../../services/hub.service';
import { EcmsStatus } from '../../types/ecms-status';
import { EcmsEntry } from '../../types/ecms-entry'


@Component({
  selector: 'remove-ecms',
  templateUrl: './remove-ecms.component.html',
  styleUrls: ['./remove-ecms.component.css'],
  providers: [HubService],
})

export class RemoveECMSComponent implements OnInit, OnChanges {
  public failFlag: boolean;

  errorMessage: string;
  newECMS = new EcmsEntry;

  isDisabled: boolean;
  isUploading: boolean;

  @Output() open_close = new EventEmitter<boolean>();

  constructor(
    private hubService: HubService,
  ) {
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.isDisabled = false;
    this.isUploading = false
    this.failFlag = false;
  }

  ngOnChanges(changes: SimpleChanges) { }

  sendFlag() {
    this.open_close.emit(false);
  }

  remove() {

    console.log(this.newECMS);

    this.isDisabled = true;
    this.isUploading = true;
    this.hubService.removeECMS(this.newECMS)
      .subscribe(
        data => {
          this.isUploading = false;
          if (data.status != "success") {
            this.failFlag = true;
          } else {
            this.sendFlag();
          }
        },
        error => {
          console.log(error);
          this.isUploading = false;
          this.failFlag = true;
        }
      );
  }

  cancel() {
    this.sendFlag();
  }
}
